export const getPincodeDetails = async (pincode) => {
  if (!/^\d{6}$/.test(pincode)) {
    return null;
  }

  const response = await fetch(
    `https://api.postalpincode.in/pincode/${pincode}`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch pincode details");
  }

  const data = await response.json();

  console.log("get the data",data)

  if (
    !Array.isArray(data) ||
    data[0]?.Status !== "Success" ||
    !data[0]?.PostOffice?.length
  ) {
    return null;
  }

  const postOffice = data[0].PostOffice[0];

  return {
    city: postOffice.Name || "",
    district: postOffice.District || "",
    state: postOffice.State || "",
  };
};